import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import AuthSetting from './components/AuthSetting';

const MemberAuthSetting = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="會員權限開通設定"
          breadcrumbs={[
            {
              name: '會員管理',
            },
            {
              name: '會員權限開通設定',
            },
          ]}
        />
        <AuthSetting />
      </Col>
    </Row>
  );
};

export default MemberAuthSetting;
